/**
 * Sidebar constants for consistent configuration
 */

// Sidebar dimensions
export const SIDEBAR_DIMENSIONS = {
  EXPANDED_WIDTH: 260,
  COLLAPSED_WIDTH: 72,
  HEADER_HEIGHT: 72,
} as const;

// Sidebar animation durations
export const SIDEBAR_ANIMATION = {
  TRANSITION_DURATION: 300,
  HOVER_DURATION: 200,
} as const;

// Sidebar spacing
export const SIDEBAR_SPACING = {
  ITEM_PADDING: 12,
  ITEM_GAP: 8,
  ICON_SIZE: 20,
  ICON_GAP: 12,
} as const;

// Sidebar colors
export const SIDEBAR_COLORS = {
  BACKGROUND: '#FFFFFF',
  BORDER: '#E5E7EB',
  TEXT_PRIMARY: '#374151',
  TEXT_SECONDARY: '#6B7280',
  ACTIVE_BACKGROUND: '#3B82F6',
  ACTIVE_TEXT: '#FFFFFF',
  HOVER_BACKGROUND: '#F3F4F6',
  HOVER_TEXT: '#111827',
} as const;

// Sidebar z-index values
export const SIDEBAR_Z_INDEX = {
  CONTAINER: 99,
  SETTINGS_DRAWER: 1300,
} as const;

// Sidebar breakpoints
export const SIDEBAR_BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1280,
} as const;

// Sidebar storage keys
export const SIDEBAR_STORAGE = {
  EXPANSION_STATE: 'sidebar_expansion_state',
  ACTIVE_ROUTE: 'sidebar_active_route',
} as const;
